module.exports = __webpack_public_path__ + "static/media/folder2.71c10eec.svg";